// extracted by mini-css-extract-plugin
export default {"eventTooltip":"CalendarEventTooltip_eventTooltip__0r36F","hidden":"CalendarEventTooltip_hidden__mAOWn"};